import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  -webkit-box-align: end;
  align-items: end;
  gap: 16px;
  height: 100%;

  > * {
    min-width: 0;
  }

  @media (max-width: 600px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;

    > div,
    > section {
      min-width: 0 !important;
      width: 100%;
    }

    button {
      width: 100%;
      min-width: 0;
      padding: 0 16px;
    }
  }
`;

export const InfoNote = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ theme }) => theme.colors.primary[80]};
  border-radius: 8px;
  padding: 14px 16px;

  font-size: 13px;
  color: ${({ theme }) => theme.colors.neutralDark[50]};

  svg {
    flex-shrink: 0;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.orange.primary};
  }

  a {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.orange.primary};
  }
`;
